module.exports = __webpack_public_path__ + "img/lottery.a5c697c9.png";